<template>
  <div class="entered-registrar">
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button size="medium" @click="dialogVisible = true">显示列名</el-button>
        <advanced-class-query @search="search" />
        <el-button size="medium" type="danger" v-if="isTeam && perKeyActive" @click="teamGroupActive">一键激活集体报名</el-button>
        <el-button size="medium" v-if="isTeam && perKeySend" @click="sendTeamMessage">待缴费短信发送</el-button>
      </div>
      <div class="search-group">
        <el-input placeholder="班级名称" v-model.trim="searchFormData.query" @keydown.native.enter="() => search()" />
        <el-button type="primary" size="medium" @click="() => search()">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :tableConfig="tableConfig"
      class="ly-card"
      :searchFormData="searchFormData"
      ref="lyTable"
    >
      <template v-slot:reserved_count_row="row">
        <span :class="countClassRes(row)">{{`${row.reserved_sign_up_count}/${row.reserved_count}`}}</span>
      </template>
      <template v-slot:minister_sign_up_count="row">
        <span :class="countClassMin(row)">{{`${row.minister_sign_up_count}/${globalConfig.minister_quota}`}}</span>
      </template>
      <template v-slot:countStatus="row">
        <span :class="countClass(row)">{{ row.sign_up_count }}/{{ row.class_count }}/{{ row.class_size }}</span>
      </template>
      <template v-slot:name="row">
        <el-button @click="showClass(row)" type="text" size="mini">{{ row.name }}</el-button>
      </template>
      <template v-slot:scud="row">
        <el-button @click="showSc(row)" type="text" size="mini">查看</el-button>
      </template>
      <template v-slot:org="row">{{
        row.fee_level.org_full_name && row.fee_level.org_full_name.replace(/中国儿童中心\/+/, '')
      }}</template>
      <template v-slot:specialized="row">{{ row.fee_level.specialized_subject_full_name }}</template>
      <template v-slot:teacher="row">{{ row.teacher | teacherFilter }}</template>
      <template v-slot:fee="row">{{ row.fee_level.name }}</template>
      <template v-slot:class_time="row">
        {{ `${row.first_class_start_time.split(' ')[0]} 至 ${row.last_class_end_time.split(' ')[0]}` }}
      </template>
      <template v-slot:class_time_sp="row">
        <div v-html="classTimeSp(row)"></div>
      </template>
      <template v-slot:class_periodic="row">
        {{ row.class_periodic | classPeriodic }}
      </template>
      <template v-slot:class_size="row">{{ row.class_size }}</template>
      <template v-slot:action="row">
        <!-- 审核通过 && 非待发布（即预发布后） -->
        <el-button
          @click="enter(row)"
          type="text"
          size="mini"
          v-if="isSignUp(row) && row.audit_status === 2 && perSignUp"
          >报名</el-button
        >
        <el-button
          @click="enter(row, 'discount')"
          type="text"
          size="mini"
          v-if="isSignUp(row) && row.audit_status === 2 && perDiscSignUp"
          >打折报名</el-button
        >
        <el-button @click="enterInf(row)" type="text" size="mini" >详情</el-button>
      </template>
    </ly-table>
    <set-table-header
      @close="dialogVisible = false"
      @change="setShowField"
      :itemKey="keyId"
      :dialogVisible="dialogVisible"
      :tableHeader="tableHeader"
      :ref="keyId"
    ></set-table-header>
    <el-dialog title="课程表" :visible.sync="dialogVisibleSc" width="1400px">
      <class-schedule :class_mode="scTime.class_mode" :class_id="scTime.class_id" />
    </el-dialog>
    <el-dialog title="班级信息" :visible.sync="dialogVisibleDetail" width="1000px">
      <class-inf-detail-list @showSc="showSc" :defaultFormItemClass="defaultFormItemClass"></class-inf-detail-list>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog, Input } from 'element-ui';

import LyTable from '@/components/LyTable';
import SetTableHeader from '@/components/SetTableHeader';
import { registrarTable } from '@/utils/tableHeaderEntered';
import { classApi } from '@/api';
import ClassInfDetailList from '@/components/ClassInfDetail/list';
import ClassSchedule from '@/components/ClassSchedule';
import AdvancedClassQuery from '@/components/AdvancedClassQuery';
import enterMixin from '@/utils/enterMixin';

export default {
  name: 'Entered',
  mixins: [enterMixin],
  components: {
    ElDialog: Dialog,
    ElInput: Input,
    LyTable,
    SetTableHeader,
    ClassInfDetailList,
    ClassSchedule,
    AdvancedClassQuery
  },
  props: {
    keyId: {
      type: String,
      required: true
    },
    perSignUp: {
      type: Boolean,
      default: () => false
    },
    perDiscSignUp: {
      type: Boolean,
      default: () => false
    },
    perDetail: {
      type: Boolean,
      default: () => false
    },
    isTeam: {
      type: Boolean,
      default: () => false
    },
    perKeyActive: {
      type: Boolean,
      default: () => false
    },
    perKeySend: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      searchFormData: {
        // 只查询审核通过的
        audit_status: 2
      },
      signDataTmp: {},
      tableHeader: [],
      getTableData: classApi.getClassInf,
      curItem: {},
      tableConfig: {
        align: 'center'
      },
      dialogVisible: false,
      dialogVisibleSc: false,
      dialogVisibleDetail: false,
      scTime: {},
      defaultFormItemClass: {}
    };
  },
  mounted() {
    this.init();
  },
  filters: {
    teacherFilter(value) {
      return (value || []).map(item => item.real_name).join(',');
    }
  },
  computed: {
    globalConfig() {
      return this.$store.state.globalConfig.data;
    },
    isSignUp() {
      // 是否还能教务报名(未结课 && (班级未满 || 预留名额有剩余))
      return row => {
        if (this.keyId === 'enteredregistrarhd' || this.keyId === 'enteredteamhd') {
          // if (
          //   row.is_rocking_number
          //   && row.rocking_number_start_time
          //   && new Date(row.rocking_number_start_time).getTime() < new Date().getTime()) {
          //   // 摇号期间不能教务报名
          //   return false;
          // }
          return (
            row.class_phase !== 3
            && (row.reserved_count > row.reserved_sign_up_count || row.sign_up_quota > 0)
          );
        }
        if (this.keyId === 'ministerhd') {
          // 是否还能部长报名(未结课)，全局预留名额由后端控制
          return row.class_phase !== 3;
        }
        return true;
      };
    },
    countClass() {
      return row => {
        if (row.class_count < row.class_size) return 'row-blue';
        if (row.class_count === row.class_size) return 'row-yellow';
        if (row.class_count > row.class_size) return 'row-red';
        return '';
      };
    },
    countClassRes() {
      return row => {
        if (row.reserved_sign_up_count < row.reserved_count) return 'row-blue';
        if (row.reserved_sign_up_count === row.reserved_count) return 'row-yellow';
        return '';
      };
    },
    countClassMin() {
      return row => {
        if (row.minister_sign_up_count < this.globalConfig.minister_quota) return 'row-blue';
        if (row.minister_sign_up_count === this.globalConfig.minister_quota) return 'row-yellow';
        return '';
      };
    },
    term() {
      return this.$store.state.schoolYear.term;
    },
    year() {
      return this.$store.state.schoolYear.year;
    }
  },
  methods: {
    init() {
      this.getHdEnum(registrarTable);
      this.$store.dispatch('globalConfig/getData');
    },
    search(data) {
      this.searchFormData = { ...this.searchFormData, ...data };
      this.$refs.lyTable.setData();
    },
    setShowField(data) {
      this.tableHeader = data;
    },
    enter(row, status) {
      this.$emit('open', row, status);
    },
    enterInf(row) {
      const routeUrl = this.$router.resolve(
        `/${this.$route.params.user_id}/classes/enrolment/${row.id}?class_phase=${row.class_phase}&name=${row.name}&fee_level=${row.fee_level.specialized_subject_full_name}`
      );
      window.open(routeUrl.href, '_blank');
    },
    showSc(row) {
      this.dialogVisibleSc = true;
      this.scTime = {
        class_mode: row.class_mode,
        class_id: row.id
      };
    },
    showClass(row) {
      this.defaultFormItemClass = { ...row };
      this.dialogVisibleDetail = true;
    },
    clear() {
      this.$refs.lyFormSignUp.resetFields();
    },
    teamGroupActive() {
      this.$emit('teamGroupActive');
    },
    sendTeamMessage() {
      this.$emit('sendTeamMessage');
    }
  }
};
</script>
<style lang="less">
.entered-registrar {
  .enter-form .el-input {
    width: 468px;
  }
  .use-reserved .el-checkbox__label {
    font-weight: 700;
  }
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 150px;
      margin-right: 20px;
    }
  }
  .field-label .el-checkbox {
    min-width: 100px;
    margin-bottom: 15px;
  }
}
.el-message-box {
  width: 450px;
}
</style>
